import LiveTvHistoryChannelList from 'pages/liveTvPage/history/LiveTvHistoryChannelList';
import WatchedPrograms from 'pages/liveTvPage/history/WatchedPrograms';
import LiveTvHistoryCoursel from 'pages/liveTvPage/history/LiveTvHistoryCoursel';
import SubText from 'components/shared/SubText';

const LiveTvDiscover = () => {
	return (
		<div>
			<div>
				<h1 className='text-white text-[30px] pt-1 pl-1 font-bold'>
					Discover programes and channels
				</h1>
			</div>
			<div>
				<div className='flex justify-between w-[95%] my-[36px] '>
					<SubText text='Programes live right now' className='font-bold' />
				</div>
				<LiveTvHistoryCoursel />
			</div>
			<div>
				<div className='flex justify-between w-[95%] my-[36px] '>
					<SubText text='Channels you might like' className='font-bold' />
				</div>
				<LiveTvHistoryChannelList />
			</div>
			<div>
				<div>
					<SubText
						text='Upcoming programes you might like'
						className='font-bold'
					/>
				</div>
				<WatchedPrograms />
			</div>
		</div>
	);
};

export default LiveTvDiscover;
